// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2vXfR","name":"Header_name__4JJ1W","birthday":"Header_birthday__2Smpn","skeleton":"Header_skeleton__2SEMz"};